export class Instancia{
    id = 0;
    descricao = '';
}